import { render, staticRenderFns } from "./CollectionItem.vue?vue&type=template&id=d149a928&scoped=true&"
import script from "./CollectionItem.vue?vue&type=script&lang=js&"
export * from "./CollectionItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItem.vue?vue&type=style&index=0&id=d149a928&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d149a928",
  null
  
)

export default component.exports